import { mount } from "svelte";
import { inject } from "@vercel/analytics";
import App from "./App.svelte";
import "./global.css";

inject();

mount(App, { target: document.getElementById("app") });
